export default ["640px", "768px", "1024px", "1280px"]